/**
 * Re-export all endpoint modules
 * insideEndpoints: Endpoints for internal Next.js API routes
 * outsideEndpoints: Endpoints for external APIs
 */

export * from "./insideEndpoints";
export * from "./outsideEndpoints";
